import create from "zustand";

interface MarketStore {
  marchesCameroun: string[];
  filteredVille: string[];
  initialize: () => void;
  searchVille: (query: string) => void;
}

const useMarketStore = create<MarketStore>((set) => ({
  marchesCameroun: [
    "Marché Central de Yaoundé",
    "Marché Mfoundi",
    "Marché Mokolo",
    "Marché Nkolndongo",
    "Marché Sandaga de Douala",
    "Marché Congo de Douala",
    "Marché Mboppi",
    "Marché de Bafoussam",
    "Marché de Bamenda",
    "Marché d'Ebolowa",
    "Marché de Ngaoundéré",
    "Marché de Garoua",
   
  ],

  filteredVille: [],

  initialize: () => set((state) => ({ filteredVille: state.marchesCameroun })),

  searchVille: (query: string) =>
    set((state) => {
      const lowercasedQuery = query.toLowerCase();
      const filtered = state.marchesCameroun.filter((fruit) =>
        fruit.toLowerCase().includes(lowercasedQuery)
      );
      return { filteredVille: filtered };
    }),
}));

export default useMarketStore;
